export enum Env {
  NEXT_PUBLIC_TRIXTA_SPACE = "smarthost.space.trixta.io"
}
